'use client';

import Link from 'next/link';
import { ClipboardList } from 'lucide-react';
import { useCart } from '@paeffgen/react/crm-documents/feature-material-requests';

export function MaterialanfrageTile() {
  const { items, itemCount } = useCart();

  // Empty state
  if (itemCount === 0) {
    return (
      <div className="border-2 border-dashed border-zinc-300 rounded-xl p-6 text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-zinc-100 mb-3">
          <ClipboardList size={24} className="text-zinc-400" />
        </div>
        <p className="text-sm font-medium text-zinc-600">Noch keine Artikel in der Anfrage</p>
        <p className="text-xs text-zinc-400 mt-1">
          Artikel aus{' '}
          <Link href="/artikelsuche" className="text-primary hover:underline">Artikelsuche</Link>
          {' '}oder{' '}
          <Link href="/favoriten" className="text-primary hover:underline">Favoriten</Link>
          {' '}hinzufügen
        </p>
      </div>
    );
  }

  const displayItems = items.slice(0, 3);

  return (
    <Link
      href="/materialanfrage"
      className="block bg-primary rounded-xl overflow-hidden text-white hover:brightness-105 transition-all group"
    >
      {/* Header */}
      <div className="p-5 pb-4">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-base font-bold uppercase tracking-wide">
              Anfrage
            </p>
            <p className="text-3xl font-bold mt-2">
              {itemCount}{' '}
              <span className="text-sm font-normal opacity-85">
                {itemCount === 1 ? 'Position' : 'Positionen'}
              </span>
            </p>
          </div>
          <div className="bg-white/20 p-2.5 rounded-xl">
            <ClipboardList size={24} />
          </div>
        </div>
      </div>

      {/* Mini position list */}
      <div className="bg-black/10 px-5">
        {displayItems.map((item, index) => (
          <div
            key={item.id}
            className={`py-2 flex justify-between text-xs ${
              index < displayItems.length - 1 ? 'border-b border-white/15' : ''
            }`}
          >
            <span className="truncate mr-4 opacity-90">
              {item.description || item.articleNumber}
            </span>
            <span className="opacity-75 whitespace-nowrap">
              {item.quantity} {item.unit}
            </span>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div className="bg-black/15 px-5 py-3.5 text-center">
        <span className="text-sm font-semibold tracking-wide group-hover:underline">
          Anfrage bearbeiten &rarr;
        </span>
      </div>
    </Link>
  );
}
